import { Component, OnInit } from '@angular/core';
import { OrderDto, PlayerDto, TacticDto } from '../../models';
import { OrderService, SecurityService, TeamService, PlayerService} from '../../services';
import { FixtureService } from 'app/services/fixture.service';
import { TeamCardsDto } from 'app/models/dtos/team-cards.dto';
import { FixtureFullDto } from 'app/models/dtos/fixture-full.dto';


@Component({
    selector: 'tactic-page',
    templateUrl: './tactic.page.html',
    styleUrls: ['./tactic.page.scss'],
})
export class TacticPage implements OnInit {
    order: OrderDto;
    isInitialized: boolean = false;
    currentTactic: TacticDto;
    
    currentTeamId: number;
    teamFormUrl: string;

    players: PlayerDto[];

    allTactics: any[];

    opponentPlayers: PlayerDto[];
     
    teamCards: TeamCardsDto;

    nextFixtureWithDetails: FixtureFullDto;

    canSetupPrice: boolean = false;


    constructor(
        private orderService: OrderService,
        private teamService: TeamService,
        private playerService: PlayerService,
        private securityService: SecurityService,
        private fixtureService: FixtureService) {
    }

    ngOnInit() { 
        this.loadData();
    }


    private loadData() {
        this.orderService.getOrder()
            .subscribe(result => {
                this.order = result;

                this.selectTactic(1);

                this.securityService.getCachedAuths() 
                    .subscribe(authResult => {
                        this.currentTeamId = authResult.primaryTeamId;

                        this.loadNextOpponent();

                        this.loadTeamCards();

                        this.teamService.getForm(this.currentTeamId)
                        .subscribe(formResult => {
                            this.teamFormUrl = formResult;

                            this.playerService.findByTeam(this.currentTeamId)
                                .subscribe(result => {
                                    
                                    this.players = result;

                                    this.isInitialized = true;
                                });

                            
                        })
                    })

                
            },
            error => {
                console.log(error);
            })
    }

    private selectTactic(number: number) {
        this.currentTactic = this.order.tactics.find(item => item.number == number);
        
    }

    private loadNextOpponent() {
        this.fixtureService.getNextOpponent()
            .subscribe(result => {

                if (result) {
                let nextOpponent = result.homeTeamId === this.currentTeamId ? result.visitorTeamId : result.homeTeamId;
                
                this.playerService.findByTeam(nextOpponent)
                    .subscribe(result => {
                        this.opponentPlayers = result;
                    })
                }
            });

        this.fixtureService.getNextOpponentWithDetails()
            .subscribe(result => {
                if (result) {
                    this.nextFixtureWithDetails = result;
                    this.canSetupPrice = result.homeTeamId == this.currentTeamId;
                }
            });
    }



    private loadTeamCards() {
        this.teamService.getCards(this.currentTeamId)
            .subscribe(result => {
                this.teamCards = result;
            })
    }
}
